import DuplicateModal from '../../Components/DuplicateModal/DuplicateModal';
import { EnumStatus, ProductItem } from 'src/types/common/product';
import React from 'react';
import _ from 'lodash';
import { duplicateProduct } from '../../tools/commonRequests';
import { store } from 'src/store';

export const copyProd = (name, status: EnumStatus, product: ProductItem) => {
  const _p = _.cloneDeep(product);
  _p.uuid = null;
  _p.name = name;
  _p.status = status;
  return _p;
};

export const onDuplicates = (
  onSubmit,
  setShowModal,
  setModalContent,
  setModalTitle,
  status,
  processData?,
) => {
  return onSubmit({
    cb: (product) => {
      onCopy(
        status,
        setShowModal,
        setModalContent,
        setModalTitle,
        product,
        processData,
      );
    },
    hideMsg: true,
  });
};
const onCopy = (
  status,
  setShowModal,
  setModalContent,
  setModalTitle,
  product,
  processData?,
) => {
  const radioList = [
    {
      label: 'Set as draft',
      value: EnumStatus.Draft,
      disable: false,
    },
    {
      label: 'Set as active',
      value: EnumStatus.Active,
      disable: status !== EnumStatus.Active,
    },
  ];
  setShowModal(true);
  setModalContent(
    <DuplicateModal
      setModal={setShowModal}
      onSubmit={(obj) => {
        const { productStatus, title } = obj;
        submit(title, productStatus, product, processData);
      }}
      radioList={radioList}
      status={status}
    />,
  );
  setModalTitle('Duplicate product');
};
const submit = (name, status, product, processData?) => {
  let prod = copyProd(name, status, product);
  if (processData) {
    prod = processData(prod);
  }
  store.dispatch(duplicateProduct(prod));

  // const { uuid, productType } = prod;

  // const url = {
  //   [EnumProductType.Simple]: 'simpleProduct',
  //   [EnumProductType.Set]: 'productSet',
  //   [EnumProductType.Variant]: 'variantProduct',
  // }[productType];
  //if (url) history.push(`/product/${url}/${uuid}`);
};
